<div class="leftPanel">
  <!-- Logo placeholder -->
  <div class="logo">
    <a ng-href="/new"> <img [src]="logoImagePath" alt="Rozie"/></a>
  </div>

  <!-- Navigation links -->
  <div class="navigation">
    <ul>
      <li>
        <a href="#">
          <span>
            <img [src]="chatImagePath" alt="" />
          </span>
          <!-- <span>Unknown Requests</span> -->
          <span>Conversation Review</span>
        </a>
      </li>
      <li>
        <a [class]="currentPath == '/'? 'activeMenu': ''" routerLink="/">
          <span>
            Transcripts
          </span>
          <span class="rightArrow" *ngIf="currentPath == '/'">
            <img [src]="combinedImagePath" alt="" />
          </span>
        </a>
      </li>
      <li>
        <a [class]="currentPath == '/unknownrequest'? 'activeMenu': ''" routerLink="/unknownrequest">
          <span>Unknown Requests</span>
          <span class="rightArrow" *ngIf="currentPath == '/unknownrequest'">
            <img [src]="combinedImagePath" alt="" />
          </span>
        </a>
      </li>
    </ul>
  </div>

  <!-- User Profile -->
  <div class="userProfile">
    <span class="profileImg">
      <mat-icon>face</mat-icon>
      <!-- <img [src]="ovalImagePath" alt="" /> -->
    </span>
    <span>{{userDisplayName}}</span>
    <span class="rightArrow"  [matMenuTriggerFor]="menuMain">
      <img [src]="combinedImagePath" alt="" />
    </span>
    <mat-menu #menuMain="matMenu">
      <button mat-menu-item (click)="logout()">
          <mat-icon>subdirectory_arrow_right</mat-icon>
          <span>Logout</span>
      </button>
    </mat-menu>
  </div>
</div>


